import React from 'react';
import {Layout} from 'antd';
import {siderCollapsedExpand} from "../../redux/actions/global";
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';

const {Sider} = Layout;


class CkContentLayout extends React.Component {

    onCollapse = (collapsed) => {
        this.props.siderCollapsedExpand(collapsed);
    };

    render() {

        var clonedSiderMenuWithMoreProps = this.props.siderMenu ? React.cloneElement(
            this.props.siderMenu,
            {
                selectedKey: this.props.routes.slice(1, 5).map(r => r.path).join("/"),
            }
        ) : null;


        return (
            <Layout className={"ant-layout-has-sider"}>
                {
                    clonedSiderMenuWithMoreProps ? <Sider
                        className={"left-sider " + (this.props.route.siderTheme && this.props.route.siderTheme == "light" ? "menu-sider" : "")}
                        collapsible
                        width={176}
                        collapsed={this.props.siderCollapsed || (this.props.moduleMenuSider ? true : false)}
                        onCollapse={this.onCollapse}>
                        {clonedSiderMenuWithMoreProps}
                    </Sider> : null
                }

                {this.props.moduleMenuSider ? this.props.moduleMenuSider : null}


                {this.props.moduleMenuSider ? this.props.moduleMenuSider.props.children : this.props.children}

            </Layout>
        )
    }
}


const mapStateToPorps = state => {
    const {siderCollapsed} = state.global;
    return {siderCollapsed};
};
const mapDispatchToProps = dispatch => ({
    siderCollapsedExpand: bindActionCreators(siderCollapsedExpand, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(CkContentLayout);



// WEBPACK FOOTER //
// ./src/components/ck/CkContentLayout.jsx